/* eslint-disable import/no-unresolved */
import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { useTranslation } from 'react-i18next';
import stripeIcon from 'images/integrations/stripe.png';
import mercadoPagoIcon from 'images/integrations/mercado-pago.svg';
import payphoneIcon from 'images/integrations/payphone.png';
import nequiByWavaIcon from "images/integrations/nequi_by_wava.png";
import daviplataByWavaIcon from "images/integrations/daviplata_by_wava.png";
import mercatelyIcon from "images/new_isotipo.png";

const PLATFORM_CONFIG = {
  stripe: {
    icon: stripeIcon,
    label: 'Stripe'
  },
  mercado_pago: {
    icon: mercadoPagoIcon,
    label: 'Mercado Pago'
  },
  payphone: {
    icon: payphoneIcon,
    label: 'Payphone'
  },
  nequi: {
    icon: nequiByWavaIcon,
    label: 'Nequi'
  },
  daviplata: {
    icon: daviplataByWavaIcon,
    label: 'Daviplata'
  },
  wompi: {
    customIcon: true,
    bgColor: 'tw-bg-[#00C389]',
    textColor: 'tw-text-white',
    letter: 'W',
    label: 'Wompi'
  },
  manual: {
    isManual: true,
    label: 'Manual',
    icon: mercatelyIcon
  }
};

const PaymentPlatformIcon = ({ service, isManualSuccess = false }) => {
  const { t } = useTranslation('DigitalPayments');
  const config = PLATFORM_CONFIG[service] || PLATFORM_CONFIG.manual;
  const tooltipId = `platform-tooltip-${service}-${Math.random().toString(36).substr(2, 9)}`;

  const getTooltipContent = () => {
    if (isManualSuccess && service === 'manual') {
      return t('platform.manual_success_tooltip');
    }
    return config.label;
  };

  const renderIcon = () => {
    if (config.isManual) {
      return (
        <div
          className="tw-w-7 tw-h-7 tw-rounded-full tw-flex tw-items-center tw-justify-center"
          data-tooltip-id={tooltipId}
          data-tooltip-content={getTooltipContent()}
        >
          <img
            src={config.icon}
            alt={config.label}
            className="tw-w-5 tw-h-5 tw-object-contain"
          />
        </div>
      );
    }

    if (config.customIcon) {
      return (
        <div
          className={`tw-w-7 tw-h-7 tw-rounded-full ${config.bgColor} tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-bold ${config.textColor}`}
          data-tooltip-id={tooltipId}
          data-tooltip-content={config.label}
        >
          {config.letter}
        </div>
      );
    }

    return (
      <div
        className="tw-w-7 tw-h-7 tw-rounded-full tw-bg-white tw-flex tw-items-center tw-justify-center tw-overflow-hidden"
        data-tooltip-id={tooltipId}
        data-tooltip-content={config.label}
      >
        <img
          src={config.icon}
          alt={config.label}
          className="tw-w-5 tw-h-5 tw-object-contain"
        />
      </div>
    );
  };

  return (
    <div className="tw-inline-flex tw-items-center">
      {renderIcon()}
      <ReactTooltip
        id={tooltipId}
        place="top"
        className="tw-max-w-xs tw-z-50"
      />
    </div>
  );
};

export default PaymentPlatformIcon;


